// Azerbaijan banks catalog with brand palettes for card visualization.
export const AZ_BANKS = [
  { key: "kapital",  name: "Kapital Bank",  short: "KB",  primary: "#e11d48", secondary: "#7f1d1d" },
  { key: "abb",      name: "ABB",           short: "ABB", primary: "#1e40af", secondary: "#0b2664" },
  { key: "pasha",    name: "PASHA Bank",    short: "PB",  primary: "#0b6e4f", secondary: "#053b2b" },
  { key: "respublika", name: "Bank Respublika", short: "BR", primary: "#1d4ed8", secondary: "#1e3a8a" },
  { key: "uni",      name: "Unibank",       short: "UB",  primary: "#ea580c", secondary: "#7c2d12" },
  { key: "rabite",   name: "Rabitəbank",    short: "RB",  primary: "#0284c7", secondary: "#0c4a6e" },
  { key: "yelo",     name: "Yelo Bank",     short: "YB",  primary: "#f59e0b", secondary: "#78350f" },
  { key: "access",   name: "AccessBank",    short: "AB",  primary: "#dc2626", secondary: "#7f1d1d" },
  { key: "afb",      name: "AFB Bank",      short: "AFB", primary: "#4f46e5", secondary: "#312e81" },
  { key: "baku",     name: "Bank of Baku",  short: "BB",  primary: "#0ea5e9", secondary: "#0c4a6e" },
  { key: "xalq",     name: "Xalq Bank",     short: "XB",  primary: "#059669", secondary: "#064e3b" },
  { key: "btb",      name: "Bank BTB",      short: "BTB", primary: "#7c3aed", secondary: "#4c1d95" },
  { key: "express",  name: "Expressbank",   short: "EB",  primary: "#be123c", secondary: "#4c0519" },
  { key: "vtb",      name: "VTB Azərbaycan", short: "VTB", primary: "#0d47a1", secondary: "#082567" },
  { key: "turan",    name: "Turanbank",     short: "TB",  primary: "#1e293b", secondary: "#020617" },
  { key: "azer",     name: "AzerTürkBank",  short: "ATB", primary: "#dc2626", secondary: "#450a0a" },
];

export const getBank = (key) => AZ_BANKS.find((b) => b.key === key) || null;
